/*
 * @Description:
 * @Autor: Dai YueLin
 * @Date: 2022-04-13 17:45:19
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-11-11 11:13:13
 */
const getters = {
  token: (state: any) => state.user.token,
  currentTab: (state: any) => state.user.currentTab,
  priList: (state: any) => state.user.priList || [],
  privilegeBtns: (state: any) => state.user.privilegeBtns || [],
  roles: (state: any) => state.user.roles,
  menuOptions: (state: any) => {
    return state.user.priList.map((item: any) => ({
      label: item.label,
      key: item.key,
      name: item.children.length > 0 ? item.children[0].name : item.name,
      icon: item.icon,
      type: item.type,
      children: item.children,
    }));
  },
  name: (state: any) => state.user.name,
  account: (state: any) => state.user.account,
  userInfo: (state: any) => state.user.userInfo,
};
export default getters;
